<template>
  <div class="app-container">
    <div class="toolbar">
      <!-- <el-form :inline="true" :model="filters" :size="size"> -->
      <!-- <el-form-item label="考勤组名称" prop="name"> -->
      <div style="display: flex; align-items: center; margin-bottom: 10px">
        <div>考勤组名称</div>
        <el-input
          style="width: 210px; margin: 0 10px"
          size="mini"
          clearable
          v-model="filters.name"
          placeholder="考勤组名称"
          auto-complete="off"
          @keyup.enter="handleEnter"
        ></el-input>
        <el-button
          class="el-icon-search"
          size="mini"
          type="primary"
          @click="findPage('up')"
          >搜索</el-button
        >
      </div>

      <!-- </el-form-item> -->

      <!-- </el-form> -->
    </div>
    <div class="table-list">
      <div class="addToolbar">
        <el-button type="primary" :size="size" @click="handleAdd1"
          >新增</el-button
        >
        <el-form :inline="true" :size="size" style="float: right">
          <el-form-item>
            <el-button-group>
              <el-tooltip content="刷新" placement="top">
                <el-button icon="fa el-icon-refresh" @click="findPage(null)" />
              </el-tooltip>
            </el-button-group>
          </el-form-item>
        </el-form>
      </div>
      <!--表格内容栏-->
      <el-table
        v-if="pageResult.data"
        :data="pageResult.data.list"
        stripe
        height="450"
        :size="size"
      >
        <el-table-column
          prop="name"
          label="考勤组名称"
          width="240"
          show-overflow-tooltip
        />
        <el-table-column prop="userCount" label="人数" width="120" />
        <!-- <el-table-column prop="Name" label="类型" width="150" /> -->
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">{{
            parseTime(scope.row.createTime)
          }}</template>
        </el-table-column>
        <!-- <el-table-column prop="week" label="考勤时间" /> -->
        <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="toolbar" style="padding: 10px" v-if="total > 0">
        <pagination
          :total="total"
          :page.sync="filters.pageNum"
          :limit.sync="filters.pageSize"
          @pagination="findPage"
        />
      </div>
    </div>
    <PopupFrame
      :dialogVisible.sync="detailpage"
      :title="title"
      class="headerts editdrawer"
      @getList="getList"
    >
      <div style="margin-bottom: 30px">
        考勤组名称：<el-input
          style="width: 300px; margin-right: 20px"
          v-model="QName"
          placeholder="请输入考勤组名称"
          :trim="true"
        ></el-input>
        <el-button type="primary" @click="updateQName">保存</el-button>
      </div>
      <div style="margin-bottom: 4px">
        考勤人员
        <el-button type="text" class="button" @click="setPeople"
          >设置</el-button
        >
      </div>
      <div
        class="des"
        v-if="selectList.length == 0 && selectdepartList.length == 0"
      >
        参与考勤人员：未设置
      </div>
      <div class="des">
        参与考勤人员({{ selectList.length }}人)：<span>
          <el-tag
            v-for="(item, index) in selectList"
            :key="index"
            style="margin: 3px"
            size="small"
            >{{ item.name }}</el-tag
          >
          <el-tag style="margin: 3px" type="info" v-if="selectList.length == 0"
            >暂无人员</el-tag
          >
        </span>
      </div>
      <!-- <div class="des" v-if="selectList.length == 0">参与考勤部门：未设置</div> -->
      <div class="des">
        参与考勤部门({{ selectdepartList.length }}个)：<span>
          <!--         closable
            @close="handleClose(item)" -->
          <el-tag
            v-for="(item, index) in selectdepartList"
            :key="index"
            style="margin: 3px"
            size="small"
            >{{ item.deptName }}</el-tag
          >
          <el-tag
            style="margin: 3px"
            type="info"
            v-if="selectdepartList.length == 0"
            >暂无部门</el-tag
          >
        </span>
      </div>
      <!-- 打卡时间 -->
      <div style="margin-bottom: 4px; margin-top: 50px">
        考勤时间
        <el-button type="text" class="button" @click="setTime">设置</el-button>
      </div>
      <div class="des" v-if="weekList.length > 0">
        工作日设置：<span
          style="margin: 0 6px"
          v-for="(item, index) in weekList"
          :key="index"
          >{{ item }}</span
        >
      </div>
      <div class="des" v-else>工作日设置：未设置</div>
      <!-- 补卡规则 -->
      <div style="margin-bottom: 4px; margin-top: 50px">
        补卡规则设置
        <el-button type="text" class="button" @click="repairRulesSetUp"
          >设置</el-button
        >
      </div>
      <div class="des" v-if="repairList != null">
        <div>规则名称：{{ repairList.name }}</div>
        <div>补卡次数：每个月可提交{{ repairList.repairNum }}次</div>
        <div>补卡时间：可申请最近{{ repairList.timeFrame }}天的补卡</div>
      </div>
      <div class="des" v-else>补卡规则：<span>未设置</span></div>
      <!-- <div class="des">无需考勤人员：未设置</div> -->

      <!-- <div class="des">考勤类型：固定班制 (固定时间上下班)</div> -->

      <div style="margin-bottom: 4px; margin-top: 50px">
        打卡方式
        <el-button type="text" class="button" @click="clockIn">设置</el-button>
      </div>
      <div class="des" v-if="checkList.length > 0">
        考勤方式：<span>{{ checkList + "" }}</span>
      </div>
      <div class="des" v-else>考勤方式：<span>未设置</span></div>
    </PopupFrame>

    <!-- 考勤人员 弹框 -->
    <el-drawer
      title="考勤人员"
      :visible.sync="People"
      destroy-on-close
      class="editdrawer OA"
      size="32%"
    >
      <div class="xiangqing">
        <el-form
          :model="dataFormPeople"
          :rules="dataRulePeople"
          label-width="90px"
          ref="dataFormPeople"
          label-position="top"
          style="margin-bottom: 45px"
        >
          <el-form-item label="参与考勤人员" prop="value1">
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              @click="openTree()"
              >选择人员</el-button
            >
            <el-button type="warning" plain @click="openClock"
              >删除人员</el-button
            >
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              @click="opendepartTree()"
              >选择部门</el-button
            >
            <!-- <el-input
              @focus="openTree"
              placeholder="未设置"
              suffix-icon="el-icon-arrow-down"
              v-model="peopleList"
              :readonly="true"
            >
            </el-input> -->
          </el-form-item>
          <el-form-item label="考勤人员" prop="value1">
            <el-tag
              style="margin: 5px"
              type="info"
              v-for="(item, index) in peopleList"
              :key="index"
              >{{ item }}</el-tag
            >
            <el-tag
              style="margin: 5px"
              type="info"
              v-if="peopleList.length == 0"
              >暂无人员</el-tag
            >
          </el-form-item>
          <el-form-item label="考勤部门" prop="value1">
            <el-tag
              style="margin: 5px"
              type="info"
              v-for="(item, index) in selectdepartList"
              :key="index"
              >{{ item.deptName }}</el-tag
            >
            <el-tag
              style="margin: 5px"
              type="info"
              v-if="selectdepartList.length == 0"
              >暂无部门</el-tag
            >
          </el-form-item>
        </el-form>
        <div
          class="demo-drawer__footer demo-drawer__footer_bottom"
          v-if="title != '员工信息详情'"
        >
          <el-button @click="People = false">取消</el-button>
          <el-button
            type="primary"
            :loading="PeopleLoading"
            @click="submitForm()"
            >确定</el-button
          >
        </div>
      </div>
    </el-drawer>
    <!-- 组织树 -->
    <tree
      @update="closeTree"
      @sendList="getSelectList($event)"
      :open="open"
      :list="selectList"
      v-if="open"
      :companyId="EId"
      :url="url"
    ></tree>
    <zhDepatrTree
      @update="closedepartTree"
      @getdepartSelectList="getdepartSelectList($event)"
      :departopen="departopen"
      :selectdepartList="selectdepartList"
      v-if="departopen"
      :companyId="EId"
      :url="url"
    ></zhDepatrTree>
    <!-- 考勤时间 弹框 -->
    <el-drawer
      title="考勤时间"
      :visible.sync="Time"
      destroy-on-close
      class="editdrawer OA"
      size="38%"
    >
      <div class="xiangqing">
        <el-form
          :model="dataFormTime"
          :rules="dataRuleTime"
          label-width="90px"
          ref="dataFormTime"
          label-position="top"
        >
          <!-- <el-form-item label="考勤类型" prop="type" style="margin-top: 15px">
              <el-radio-group v-model="dataFormTime.type" style="color: #000">
                <el-radio :label="1"
                  >固定班制(固定时间上下班)<br />
                  <div class="des" style="margin: 6px 24px 20px">
                    考勤组中所有人按照相同的时间打卡，适用于办公室坐班，例如朝九晚五
                  </div>
                </el-radio>
                <el-radio :label="2"
                  >排班制(按排班上下班)<br />
                  <div class="des" style="margin: 6px 24px 20px">
                    自定义设置每人的班次，适用于工厂、门店等，例如三班倒
                  </div>
                </el-radio>
                <el-radio :label="3"
                  >自由工时(不固定时间上下班)<br />
                  <div class="des" style="margin: 6px 24px 20px">
                    上下班时间不固定，可随时打卡，适用于销售以及装修、家政等计时工
                  </div>
                </el-radio>
              </el-radio-group>
            </el-form-item> -->
          <el-tabs v-model="tabsModel" @tab-click="tabsHandleClick">
            <el-tab-pane label="正常考勤" name="1" />
            <el-tab-pane label="跨天考勤" name="4" />
          </el-tabs>
          <el-form-item label="工作日设置" prop="date">
            <el-table
              :header-cell-class-name="cellClass"
              :data="tableData"
              border
              style="width: 100%"
              @selection-change="handleSelectionChange"
              @select="onTableSelect"
              size="mini"
              ref="multipleTable"
              :row-key="
                (row) => {
                  return row.id;
                }
              "
            >
              <el-table-column
                type="selection"
                align="center"
                width="55"
                :reserve-selection="true"
              >
              </el-table-column>
              <el-table-column prop="week" label="工作日" width="120">
                <template slot-scope="{ row }">
                  <span v-if="row.week == 1">周一</span>
                  <span v-if="row.week == 2">周二</span>
                  <span v-if="row.week == 3">周三</span>
                  <span v-if="row.week == 4">周四</span>
                  <span v-if="row.week == 5">周五</span>
                  <span v-if="row.week == 6">周六</span>
                  <span v-if="row.week == 7">周日</span>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="上班时间">
                <template slot-scope="{ row }">
                  <span v-if="row.isSelect == 1"
                    >{{ row.beginTime }} - {{ row.endTime }}</span
                  >
                  <span v-if="row.isSelect == 0">休息</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    @click="handleEditTime(scope.row)"
                    >修改时间</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" v-if="title != '员工信息详情'">
          <!-- <el-button @click="Time = false">取消</el-button> -->
          <el-button
            :loading="TimeLoading"
            type="primary"
            @click="submitFormTime()"
            >保存</el-button
          >
        </div>
      </div>
    </el-drawer>

    <!-- 修改 考勤班次 弹框 -->
    <el-dialog
      title="修改班次时间"
      :visible.sync="workTime"
      width="32%"
      destroy-on-close
    >
      <el-form v-model="workTimeForm">
        <el-form-item v-if="!isSurpassTime" label="班次时间">
          <el-time-picker
            is-range
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            v-model="workTimeForm.time"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item v-else label="班次时间">
          <!-- 跨天考勤时间选择 -->
          <br />
          <el-time-picker
            style="width: 150px;"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            v-model="workTimeForm.surpassStartTime"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            placeholder="开始时间"
          >
          </el-time-picker>
          <span style="margin: 0 8px;">至</span>
          <el-time-picker
            style="width: 150px;"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            v-model="workTimeForm.surpassEndTime"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            placeholder="结束时间"
            :key="!isSurpassTime"
          >
          </el-time-picker>
        </el-form-item>
        
        <el-form-item label="类型" prop="type">
<el-radio-group v-model="workTimeForm.type">
    <el-radio :label="1">固定班制</el-radio>
    <el-radio :label="3">自由工时</el-radio>
  </el-radio-group>
              
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="workTime = false">取 消</el-button>
        <el-button type="primary" @click="editWorkTime">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 打卡方式 弹框 -->
    <el-drawer
      title="打卡方式"
      :visible.sync="Clock"
      destroy-on-close
      class="editdrawer OA"
      size="38%"
    >
      <div class="xiangqing">
        <el-form
          :model="dataFormClock"
          :rules="dataRuleClock"
          label-width="90px"
          ref="dataFormClock"
          label-position="top"
        >
          <el-form-item label="考勤方式" prop="type">
            <el-checkbox-group v-model="checkList" @change="getClockType">
              <el-checkbox label="地点打卡"></el-checkbox>
              <br />
              <el-checkbox label="Wi-Fi打卡"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- 地点打卡 表格 -->
          <div v-if="positionShow">
            <div style="font-size: 14px">地点</div>
            <el-button
              size="small"
              style="margin: 10px 10px 10px 0"
              @click.native="openMap(dataFormClock)"
              >添 加</el-button
            ><span style="font-size: 14px; color: #606266"
              >可添加多个办公地点</span
            >
            <el-table
              header-cell-style="background-color: #f1f2f3;"
              :data="positionTable"
              style="width: 100%"
              size="mini"
            >
              <el-table-column prop="name" label="考勤地址" width="350">
                <template slot-scope="scope">
                  <el-button
                    style="color: #606266"
                    type="text"
                    @click.native="openMap1(scope.row, scope.$index)"
                    >{{ scope.row.name }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column prop="range" label="有效范围" width="120">
                <template slot-scope="{ row }">
                  <el-select v-model="row.range" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label + '米'"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    @click="delPosition(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--Wifi打卡 表格 -->
          <div v-if="WifiShow" style="margin-top: 30px">
            <div style="font-size: 14px">Wi-Fi</div>
            <el-button
              size="small"
              style="margin: 10px 10px 10px 0"
              @click.native="openWifi()"
              >添 加</el-button
            ><span style="font-size: 14px; color: #606266"
              >可添加多个办公Wi-Fi</span
            >
            <el-table
              header-cell-style="background-color: #f1f2f3;"
              :data="WifiTable"
              style="width: 100%"
              size="mini"
            >
              <el-table-column prop="name" label="名称" width="200">
              </el-table-column>
              <el-table-column prop="MAC" label="MAC地址" width="260" />
              <el-table-column label="操作" fixed="right" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    @click="delWifi(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
        <div class="demo-drawer__footer">
          <!-- <el-button @click="Time = false">取消</el-button> -->
          <el-button
            :loading="ClockLoading"
            type="primary"
            @click="submitFormClock()"
            >保存</el-button
          >
        </div>
      </div>
    </el-drawer>

    <!-- 定位经纬度 -->
    <el-dialog
      title="标记坐标点"
      width="80%"
      height="100%"
      :visible.sync="dialogVisibles"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      append-to-body
      class="map"
    >
      <txMapDraw
        ref="child"
        @saveTxMapPoint="getMsgFormSon"
        :type="enterType"
        :marker="dataFormClock.position"
      />
      <!--      <mapUpdata-->
      <!--        ref="child"-->
      <!--        :Coordinate="dataFormClock.position"-->
      <!--        :type="enterType"-->
      <!--        @func="getMsgFormSon"-->
      <!--      />-->

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="dialogVisibles = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加wifi 弹框 -->
    <el-dialog
      @close="closeWifi"
      title="添加办公Wifi"
      :visible.sync="Wifi"
      width="30%"
    >
      <el-form :model="WifiForm">
        <el-form-item label="名称">
          <el-input
            v-model="WifiForm.name"
            placeholder="请输入Wifi名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="MAC地址">
          <el-input
            v-model="WifiForm.MAC"
            placeholder="请输入MAC地址(02:10:18:02:40:7b)"
          ></el-input>
        </el-form-item>
        <div>名称尽量保持与考勤WiFi名称一致，避免员工产生误解</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeWifi">取 消</el-button>
        <el-button type="primary" @click="addWifi" :loading="addLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 删除考勤人员 -->
    <el-dialog
      @close="closeClock"
      title="请选择要删除的考勤人员"
      :visible.sync="closeClockVisible"
      width="55%"
    >
      <div>
        <el-row :gutter="24">
          <!--部门数据-->
          <el-col :span="16">
            <el-input
              v-model="searchQuery"
              placeholder="请输入员工姓名"
              prefix-icon="el-icon-search"
              clearable
              style="margin-bottom: 20px; width: 300px"
            ></el-input>
            <el-table
              height="484"
              :data="filteredData"
              ref="multipleTable"
              row-key="userId"
              @selection-change="handleSelectionChangeDelet"
            >
              <el-table-column
                :reserve-selection="true"
                type="selection"
                width="50"
              />
              <el-table-column
                label="姓名"
                prop="name"
                width="120"
                :show-overflow-tooltip="true"
              />
              <el-table-column label="手机号码" prop="phone" min-width="120" />
            </el-table>
          </el-col>
          <!-- 已勾选的人员数据 -->
          <el-col :span="8" style="height: 524px">
            <div
              style="
                margin-bottom: 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>
                已选人员(<span style="color: #1890ff">{{
                  selectListDelet.length
                }}</span
                >)
              </div>
              <el-button type="text" @click="clearAllDelet">清空</el-button>
            </div>
            <div
              style="
                margin: 28px;
                overflow-y: auto;
                height: 480px;
                padding-right: 20px;
              "
              v-if="selectListDelet.length > 0"
            >
              <div
                v-for="(item, index) in selectListDelet"
                :key="index"
                style="
                  margin-bottom: 15px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span>{{ item.name }}</span>
                <span>{{ item.phone }}</span>
              </div>
            </div>
            <div v-else>
              <el-empty description="请选择要删除的人员"></el-empty>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="commonDialog-footer">
        <el-button type="primary" @click="distribeDelet" :loading="editLoading"
          >确 定</el-button
        >
        <el-button @click="closeClock">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 补卡规则 -->
    <el-drawer
      title="补卡规则"
      :visible.sync="repairRulesVisible"
      destroy-on-close
      class="editdrawer OA"
      size="35%"
    >
      <div class="xiangqing">
        <el-table
          ref="repairRulesRef"
          :data="repairRulesList"
          @current-change="handleRepairRules"
          highlight-current-row
        >
          <el-table-column width="55">
            <template slot-scope="scope">
              <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
              <el-radio
                class="radio"
                v-model="templateSelection"
                :label="scope.row.id"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>

          <el-table-column label="规则名称" align="center" prop="name" />
          <el-table-column label="补卡次数" align="center" prop="repairNum" />
          <el-table-column
            label="时间范围(天)"
            align="center"
            prop="timeFrame"
          />
        </el-table>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="repairRulesVisible = false">取消</el-button>
        <el-button
          :loading="ClockLoading"
          type="primary"
          @click="submitFormRepairRules()"
          >保存</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {
  getManagementList,
  getManagementListNew,
  addStaff,
  deleteManagement,
  insertManagement,
  getListRuleByManagementId,
  attendanceRuleUpdateBatch,
  updateManagement,
  getTypeByManagementId,
  insertClockInType,
  zhInsertClockInPersonnel,
  getSysUserList,
  zhInsertClockInPersonnelDelUser,
  clockInGetDeptById,
} from "@/api/Industry";
import {
  repairRuleList,
  repairRuleManagementBg,
  addRepairRuleManagement,
  updateRepairRuleManagement,
} from "@/api/clockIn";
import PopupFrame from "@/components/PopupFrame";
import mapUpdata from "@/components/mapUpdata";
import tree from "./zhTree.vue";
import zhDepatrTree from "./zhDepatrTree.vue";
import txMapDraw from "@/components/txMapDraw/index.vue";
export default {
  components: {
    txMapDraw,
    PopupFrame,
    tree,
    mapUpdata,
    zhDepatrTree,
  },
  data() {
    return {
      EId: this.$route.query.EId,
      url: this.$route.query.url,
      platformId: this.$route.query.platformId,
      options: [
        {
          value: 50,
          label: "50",
        },
        {
          value: 100,
          label: "100",
        },
        {
          value: 200,
          label: "200",
        },
        {
          value: 300,
          label: "300",
        },
        {
          value: 400,
          label: "400",
        },
        {
          value: 500,
          label: "500",
        },
        {
          value: 600,
          label: "600",
        },
        {
          value: 700,
          label: "700",
        },
        {
          value: 800,
          label: "800",
        },
        {
          value: 900,
          label: "900",
        },
        {
          value: 1000,
          label: "1000",
        },
        {
          value: 2000,
          label: "2000",
        },
        {
          value: 3000,
          label: "3000",
        },
      ],
      index: "",
      enterType: "", // 进去地图组件的方式 是新增 还是编辑
      clockType: "",
      WifiForm: { name: "", MAC: "" },
      contentList: [],
      checkList: [],
      TimeLoading: false,
      PeopleLoading: false,
      ClockLoading: false,
      positionShow: false,
      WifiShow: false,
      EList: [], // 企业列表
      People: false,
      Time: false,
      Clock: false,
      Wifi: false,
      open: false,
      selectList: [], // 勾选人员数组
      dialogFull: false,
      peopleList: "", // 考勤人员
      tableData: [], // 考勤日期 表格
      workTime: false, // 考勤班次 弹框
      workTimeForm: {
          id: null,
  beginTime: "",
  endTime: "",
  type: 1,
  isSelect: 1,
  time: [],
  surpassStartTime: "",
  surpassEndTime: "",
      },
      managementId: "", // 考勤组id
      weekList: [], // 考勤日期
      typeTableData: [],
      positionTable: [], // 考勤地址 表格
      WifiTable: [], // wifi 表格
      value1: [],
      dataRulePeople: {
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        EId: [{ required: true, message: "请选择企业", trigger: "change" }],
        EDId: [{ required: true, message: "请选择部门", trigger: "change" }],
        Sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        Mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      },
      title: "",
      size: "mini",
      xiangqinginput: "100px",
      dialogVisibles: false,
      editLoading: false,
      addLoading: false,
      detailpage: false,
      filters: {
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
        name: "",
        pageNum: 1,
        pageSize: 10,
      },
      deptTreeProps: {
        label: "Name",
        children: "Children",
      },
      QName: "", // 考勤组名称
      deptDatas: [],
      pageResult: {},
      total: 0,
      deptData: [],
      dataFormPeople: [
        {
          ESId: 0,
          EId: "",
          EDId: "",
          Name: "",
          Sex: "",
          Birthday: "",
          IdCard: "",
          Address: "",
          Mobile: "",
          LoginPwd: "",
          Remark: "",
        },
      ],
      dataFormTime: {},
      dataRuleTime: {
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        EId: [{ required: true, message: "请选择企业", trigger: "change" }],
      },
      dataFormClock: [],
      dataRuleClock: {
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        EId: [{ required: true, message: "请选择企业", trigger: "change" }],
      },
      closeClockVisible: false,
      selectListDelet: [],
      searchQuery: "",
      repairRulesVisible: false, //补卡规则弹窗
      repairRulesList: [], //补卡规则
      repairRulesSelectVal: null,
      repairList: null, //绑定的补卡规则
      //   当前选择的行的id
      templateSelection: "",
      headerCellStyle: {
        backgroundColor: "#f1f2f3",
      },
      departopen: false,
      selectdepartList: [],
      deptIdList: [],
      orideptIdLsit: [],
      isChangedept: false,
      tabsModel: "1",
      isSurpassTime: false, // 是否跨天考勤
    };
  },
  watch: {
    open(val, value) {
      /*  console.log(val);
      console.log(value); */
    },
    departopen(val, value) {
      /*   console.log(val);
      console.log(value); */
    },
  },
  computed: {
    filteredData() {
      const query = this.searchQuery.toLowerCase();
      return this.selectList.filter((row) =>
        Object.values(row).some((value) =>
          String(value)
            .toLowerCase()
            .includes(query),
        ),
      );
    },
  },
  methods: {
    handleEnter() {
      console.log(112233);
    },
    // 设置打卡方式
    clockIn() {
      this.Clock = true;
    },
    // 获取 多选 选中的的打卡方式
    getClockType(val) {
      console.log(val, "val");
      if (val.includes("地点打卡")) {
        this.positionShow = true;
      } else {
        this.positionShow = false;
      }
      if (val.includes("Wi-Fi打卡")) {
        this.WifiShow = true;
      } else {
        this.WifiShow = false;
      }
    },
    // 打开地图标记
    openMap: function(val) {
      var that = this;
      this.enterType = "add";
      that.dialogVisibles = true;
      // var coordinate = "[{\"lng\":114.03489862771391,\"lat\":32.990637206284006,\"Xe\":\"inner\"}]"
      that.dataFormClock.position = val.position;
      setTimeout(() => {
        that.$refs.child.fn();
      }, 1000);
    },
    // 打开地图标记
    openMap1: function(val, index) {
      console.log(val, "val");
      console.log(index, "index");
      this.index = index;
      var that = this;
      const isEdit =  val.position && val.position !== "" && val.position !== "[]";
      console.log(isEdit, "isEdit")
      this.enterType = isEdit ? "edit" : "add";
      console.log("打开地图2，模式：", this.enterType, "坐标：", val.position);
      that.dialogVisibles = true;
      that.dataFormClock.position = val.position;
      setTimeout(() => {
        that.$refs.child.pointData();
      }, 1000);
    },
    // 地图坐标保存
    getMsgFormSon: function(arr1, arr2, type) {
      console.log(arr1, "arr1"); // 坐标点
      console.log(arr2, "arr2"); // 详细地址 名称
      console.log(type, "type"); // 详细地址 名称
      this.dataFormClock.position = JSON.stringify([arr1]);
      this.dataFormClock.name = arr2;
      if (type == "add") {
        this.positionTable.push({
          name: arr2,
          position: JSON.stringify(arr1),
          range: 300,
        });
      }
      if (type == "edit") {
        this.positionTable[this.index].name = arr2;
        this.positionTable[this.index].position = JSON.stringify([arr1]);
      }
      this.dialogVisibles = false;
    },
    // 打开wifi 弹框
    openWifi() {
      this.Wifi = true;
    },
    validateMac(mac) {
      let reg1 = /^[A-Fa-f0-9]{1,2}-[A-Fa-f0-9]{1,2}-[A-Fa-f0-9]{1,2}-[A-Fa-f0-9]{1,2}-[A-Fa-f0-9]{1,2}-[A-Fa-f0-9]{1,2}$/;
      let reg2 = /^[A-Fa-f0-9]{1,2}:[A-Fa-f0-9]{1,2}:[A-Fa-f0-9]{1,2}:[A-Fa-f0-9]{1,2}:[A-Fa-f0-9]{1,2}:[A-Fa-f0-9]{1,2}$/;
      if (reg1.test(mac)) {
        return true;
      } else if (reg2.test(mac)) {
        return true;
      } else {
        return false;
      }
    },
    // 添加wifi
    addWifi() {
      if (!this.WifiForm.name) {
        this.$message({ message: "请输入wifi名称", type: "warning" });
        return;
      }
      if (!this.validateMac(this.WifiForm.MAC)) {
        this.$message({
          message: "请输入正确MAC地址，格式如：02:10:18:02:40:7b",
          type: "warning",
        });
        return;
      }
      this.WifiTable.push(this.WifiForm);
      this.Wifi = false;
      this.WifiForm = {
        name: "",
        MAC: "",
      };
    },
    // 删除wifi
    delWifi(index) {
      this.WifiTable.splice(index, 1);
    },
    // 删除 地址
    delPosition(index) {
      this.positionTable.splice(index, 1);
    },
    // 关闭 wifi 弹框
    closeWifi() {
      this.Wifi = false;
      this.WifiForm = {
        name: "",
        MAC: "",
      };
    },
    // 提交 打卡方式 表单
    submitFormClock() {
      if (this.checkList.length == 1) {
        this.checkList.forEach((i) => {
          if (i == "地点打卡") {
            this.clockType = 1;
          }
          if (i == "Wi-Fi打卡") {
            this.clockType = 2;
          }
        });
      } else if (this.checkList.length == 2) {
        this.clockType = 3;
      } else {
        this.clockType = "";
      }
      console.log(this.clockType);
      console.log(this.positionTable);
      console.log(this.WifiTable);
      var id = null;
      if (this.typeTableData[0]) {
        id = this.typeTableData[0].id;
      } else {
        id = null;
      }
      insertClockInType({
        address: JSON.stringify(this.positionTable),
        wifi: JSON.stringify(this.WifiTable),
        type: this.clockType,
        managementId: this.managementId,
        id: id,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "设置成功",
          });
          this.Clock = false;
          this.getTypeByManagementId();
        }
      });
    },
    // 修改 考勤组名称
    async updateQName(type) {
      if (this.QName.trim()) {
        console.log(111);
        let ids = "";
        if (this.deptIdList.length > 0) {
          ids = this.deptIdList.join(",");
        } else {
          ids = "";
        }
        const res = await updateManagement({
          id: this.managementId,
          name: this.QName,
          deptId: ids,
        });
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "修改考勤组名称成功",
          });
          if (type == 1) {
            this.clockInGetDeptFun();
          }
        }
      } else {
        this.$message({
          type: "warning",
          message: "考勤组名称 不能为空",
        });
      }
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
    getList() {
      this.findPage();
      this.detailpage = false;
    },
    // 设置 考勤人员
    setPeople() {
      this.People = true;
      this.PeopleLoading = false;
      var arr = [];
      console.log(this.selectList);
      this.selectList.forEach((i) => {
        arr.push(i.name);
      });
      this.peopleList = arr;
    },
    openTree() {
      this.open = true;
    },
    closeTree() {
      this.open = false;
    },
    opendepartTree() {
      this.departopen = true;
    },
    closedepartTree(e) {
      this.departopen = false;
      if (e == 2) {
        this.selectdepartList = [];
      }
      console.log(e);
    },
    // 接收 子组件传递过来 的勾选人员数组
    getSelectList(list) {
      // console.log(list, 'list')
      this.selectList = list;
      var arr = [];
      list.forEach((i) => {
        arr.push(i.name);
      });
      console.log(arr, "arr");
      this.peopleList = arr;
    },
    // 接收 子组件传递过来 的勾选人员数组
    getdepartSelectList(list) {
      console.log(list, "list");
      this.selectdepartList = list;
      const ids = [];
      list.forEach((i) => {
        ids.push(i.deptId);
      });
      this.deptIdList = ids;
    },
    // 设置 考勤时间
    setTime() {
      this.Time = true;
      var arr = [];
      this.tableData.forEach((i) => {
        if (i.isSelect == 1) {
          arr.push(i);
        }
      });
      console.log(arr);
      this.$nextTick(() => {
        arr.map((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
        // console.log(this.$refs.multipleTable)
      });
    },
    // 勾选 工作日设置表格
    handleSelectionChange(val) {
      console.log(val, "val");
    },
    onTableSelect(rows, row) {
      let selected = rows.length && rows.indexOf(row) !== -1;
      console.log(selected); // true就是选中，0或者false是取消选中
      if (selected) {
        // 选中
        this.tableData.forEach((i) => {
          if (i.id == row.id) {
            i.isSelect = 1;
          }
        });
      } else {
        // 取消选中
        this.tableData.forEach((i) => {
          if (i.id == row.id) {
            i.isSelect = 0;
          }
        });
      }
    },
    // 修改班次时间
    handleEditTime(row) {
       this.workTime = true;
  // 深拷贝数据
  this.workTimeForm = { 
    id: row.id,
    beginTime: row.beginTime,
    endTime: row.endTime,
    type: row.type || 1, // 默认固定班制
    isSelect: row.isSelect
  };
  this.$set(this.workTimeForm, "time", [
    row.beginTime + ":00",
    row.endTime + ":00",
  ]);
  this.$set(this.workTimeForm, "surpassStartTime", row.beginTime + ":00");
  this.$set(this.workTimeForm, "surpassEndTime", row.endTime + ":00");
  console.log("handleEditTime", this.workTimeForm);
    },
    // 确认 修改 班次时间
    editWorkTime() {
    if (!this.isSurpassTime) {
    // 正常考勤
    if (!this.workTimeForm.time || this.workTimeForm.time.length !== 2) {
      this.$message({
        type: "warning",
        message: "请选择完整的考勤时间",
      });
      return;
    }
    this.tableData.forEach((i) => {
      if (i.id == this.workTimeForm.id) {
        i.beginTime = this.workTimeForm.time[0].slice(0, -3);
        i.endTime = this.workTimeForm.time[1].slice(0, -3);
        i.type = this.workTimeForm.type || 1; // 保存类型
        i.isSelect = 1; // 确保为选中状态
      }
    });
  } else {
    // 跨天考勤
    if (!this.workTimeForm.surpassStartTime) {
      this.$message({
        type: "warning",
        message: "请设置开始时间",
      });
      return;
    }
    if (!this.workTimeForm.surpassEndTime) {
      this.$message({
        type: "warning",
        message: "请设置结束时间",
      });
      return;
    }
    this.tableData.forEach((i) => {
      if (i.id == this.workTimeForm.id) {
        i.beginTime = this.workTimeForm.surpassStartTime.slice(0, -3);
        i.endTime = this.workTimeForm.surpassEndTime.slice(0, -3);
        i.type = this.workTimeForm.type || 3; // 跨天考勤默认自由工时
        i.isSelect = 1;
      }
    });
  }
  console.log("修改后的数据:", this.workTimeForm);
  this.workTime = false;
    },
    // 跨天考勤逻辑
    tabsHandleClick(tab) {
      this.workTime = false;
      let val = tab.$options.propsData.name;
      val === "1" && (this.isSurpassTime = false);
      val === "4" && (this.isSurpassTime = true);
    },
    // 保存 考勤时间 设置
    async submitFormTime() {
      if (this.deptIdList.length > 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          const e = this.tableData[i];
          e.deptId = this.deptIdList.join(",");
        }
        console.log("设置时间", this.tableData);
      }
      this.TimeLoading = true;
      // deptId
      const res = await attendanceRuleUpdateBatch(this.tableData);
      if (res.code == 200) {
        this.Time = false;
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.TimeLoading = false;
        this.getListByManagementId(this.managementId);
      } else {
        this.TimeLoading = false;
      }
    },
    // 获取部门列表
    findDeptTree: function() {
      treeListDep().then((res) => {
        this.deptDatas = this.getParentMenuTree(res.data);
      });
    },
    // 获取上级机构树
    getParentMenuTree: function(tableTreeDdata) {
      const parent = {
        EDId: 0,
        Name: "顶级菜单",
        Children: tableTreeDdata,
      };
      return [parent];
    },
    //单位函数，获取小区，并单位赋值
    CompanySearchFN(data, node) {
      this.dataFormPeople.EDId = data.EDId;
      this.dataFormPeople.EDName = data.Name;
    },
    // 获取分页数据
    findPage: function(part) {
      if (part == "up") {
        this.filters.pageNum = 1;
      }
      getManagementListNew(this.filters).then((res) => {
        this.pageResult = res;
        this.total = res.data.total;
        console.log(this.pageResult);
        res.data.list.forEach((i) => {
          if (i.week.length > 0) {
            for (let j = 0; j < i.week.length; j++) {
              if (i.week[j] == 1) {
                i.week[j] = "周一";
              }
              if (i.week[j] == 2) {
                i.week[j] = "周二";
              }
              if (i.week[j] == 3) {
                i.week[j] = "周三";
              }
              if (i.week[j] == 4) {
                i.week[j] = "周四";
              }
              if (i.week[j] == 5) {
                i.week[j] = "周五";
              }
              if (i.week[j] == 6) {
                i.week[j] = "周六";
              }
              if (i.week[j] == 7) {
                i.week[j] = "周日";
              }
            }
            // console.log(i.week, ' i.week')
            i.week = i.week + "";
          }
        });
        // console.log(res.data, 'res.data')
      });
    },
    handleAdd1() {
      this.$prompt("请输入考勤组名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputPattern: /^.+$/,
        inputPattern: /^(?=.*\S).+$/,
        inputErrorMessage: "考勤组名称不能为空",
      })
        .then(({ value }) => {
          // 确定
          insertManagement({
            platformId: this.$route.query.platformId,
            companyId: this.$route.query.EId,
            name: value,
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.findPage();
              // this.handleAdd(value);
            } else {
              this.$message({
                type: "warning",
                message: res.message,
              });
            }
          });
        })
        .catch(() => {});
    },

    // 新增
    handleAdd(value) {
      console.log(value, "value");
      this.QName = value;
      this.detailpage = true;
      this.title = "新增考勤组";
      this.$nextTick(() => {
        // this.$refs["dataFormPeople"].clearValidate();
      });
      this.dataFormPeople = {
        ESId: 0,
        EId: "",
        EDId: "",
        Name: "",
        Sex: "",
        Birthday: "",
        IdCard: "",
        Address: "",
        Mobile: "",
        LoginPwd: "",
        Remark: "",
      };
    },

    // 编辑
    handleEdit(params) {
      this.QName = params.name;
      this.managementId = params.id;
      this.getListByManagementId(this.managementId);
      this.getTypeByManagementId();
      this.getUserListByManagementId();
      this.clockInGetDeptFun();
      // 获取考勤组绑定补卡规则
      this.getRepairRuleManagementList();
      this.detailpage = true;
      this.title = "修改考勤组";
      this.dataFormPeople = Object.assign({}, params);
    },

    // 获取考勤时间 表格
    async getListByManagementId(val) {
      const res = await getListRuleByManagementId({ managementId: val });
       this.tableData = res.data.map(item => ({
    ...item,
    type: item.type || 1 // 默认固定班制
  }));
      var array = [];
      this.tableData.forEach((i) => {
        if (i.isSelect == 1) {
          if (i.week == 1) {
            i.name = "周一";
          }
          if (i.week == 2) {
            i.name = "周二";
          }
          if (i.week == 3) {
            i.name = "周三";
          }
          if (i.week == 4) {
            i.name = "周四";
          }
          if (i.week == 5) {
            i.name = "周五";
          }
          if (i.week == 6) {
            i.name = "周六";
          }
          if (i.week == 7) {
            i.name = "周日";
          }
          array.push(i.name);
        }
      });
      this.weekList = array;
    },

    // 获取考勤地址 表格
    async getTypeByManagementId() {
      this.checkList = [];
      this.positionTable = [];
      this.WifiTable = [];
      const res = await getTypeByManagementId({
        managementId: this.managementId,
      });
      if (res.code == 200) {
        this.typeTableData = res.data;
        if (res.data[0]) {
          this.positionTable = JSON.parse(res.data[0].address);
          this.WifiTable = JSON.parse(res.data[0].wifi);
          if (res.data[0].type == 3) {
            this.checkList = ["地点打卡", "Wi-Fi打卡"];
          }
          if (res.data[0].type == 2) {
            this.checkList = ["Wi-Fi打卡"];
          }
          if (res.data[0].type == 1) {
            this.checkList = ["地点打卡"];
          }
        }
        // console.log(this.checkList, 'checkList')
        if (this.checkList.includes("地点打卡")) {
          this.positionShow = true;
        } else {
          this.positionShow = false;
        }
        if (this.checkList.includes("Wi-Fi打卡")) {
          this.WifiShow = true;
        } else {
          this.WifiShow = false;
        }
      }
    },
    // 获取 考勤组人员
    async getUserListByManagementId() {
      const res = await getSysUserList({
        companyId: this.$route.query.EId,
        managementId: this.managementId,
      });
      if (res.code == 200) {
        this.selectList = res.data;
      }
    },
    // 获取 考勤组部门
    async clockInGetDeptFun() {
      const res = await clockInGetDeptById({
        id: this.managementId,
      });
      if (res.code == 200) {
        console.log("考勤组部门", res);
        if (res.data) {
          this.selectdepartList = res.data;
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            this.deptIdList.push(e.deptId);
          }
          this.orideptIdLsit = this.deptIdList;
        } else {
          this.selectdepartList = [];
        }
      }
    },
    async submitForm() {
      this.PeopleLoading = true;
      let ids = "";
      if (this.deptIdList.length > 0) {
        ids = this.deptIdList.join(",");
      } else {
        ids = "";
      }
      if (this.orideptIdLsit.join(",") !== ids) {
        this.isChangedept = true;
      }
      const res = await zhInsertClockInPersonnel(
        // this.selectList
        {
          item: this.selectList,
          managementId: this.managementId,
          platformId: this.platformId,
          companyId: this.$route.query.EId,
          deptId: ids,
        },
      );
      if (res) {
        if (res.code == 200) {
          this.People = false;
          this.$message({
            type: "success",
            message: "设置成功",
          });
          this.PeopleLoading = false;
          if (this.isChangedept) {
            this.updateQName(1);
          }
          this.getUserListByManagementId();
        } else {
          this.PeopleLoading = false;
        }
      } else {
        this.PeopleLoading = false;
      }
    },
    // 删除
    handleDelete: function(row) {
      this.$confirm("确认要删除此项吗？", "提示", {}).then(() => {
        this.editLoading = true;
        deleteManagement(row.id).then((res) => {
          this.editLoading = false;
          if (res.code === 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.detailpage = false;
            this.findPage();
            this.$refs["dataFormPeople"].resetFields();
          } else {
            this.$message({ message: "删除失败, " + res.msg, type: "error" });
          }
        });
      });
    },

    // 打开考勤人员弹窗
    openClock() {
      this.closeClockVisible = true;
      this.selectListDelet = [];
    },
    // 关闭考勤人员弹窗
    closeClock() {
      this.closeClockVisible = false;
      this.searchQuery = "";
      this.selectListDelet = [];
    },
    // 清空选中的人员
    clearAllDelet() {
      this.selectListDelet = [];
    },
    // 多选框选中数据
    handleSelectionChangeDelet(selection) {
      var selectionList = [];
      this.multipleSelection = selection;
      selection.forEach((e) => {
        selectionList.push({
          userId: e.id,
          dptmntName: e.deptName,
          companyId: e.companyId,
          deptId: e.deptId,
          sex: e.sex,
          name: e.name,
          phone: e.phone,
          platformId: this.$route.query.platformId,
        });
      });
      this.selectListDelet = selectionList;
      this.ids = selection.map((item) => item.userIds);
    },
    handleClose(tag) {
      var userIdList = [tag.userId];
      this.$confirm("确认要删除" + tag.name + "的考勤吗？", "提示", {}).then(
        () => {
          this.editLoading = true;
          zhInsertClockInPersonnelDelUser(userIdList)
            .then((res) => {
              if (res.code === 200) {
                this.$message({ message: "删除成功", type: "success" });
                this.getUserListByManagementId();
                this.closeClock();
              } else {
                this.$message({
                  message: "删除失败, " + res.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {});
        },
      );
    },
    // 删除考勤人员确定按钮
    distribeDelet() {
      if (this.selectListDelet.length <= 0) {
        this.$message({
          type: "warning",
          message: "请选择要删除的人员",
        });
        return;
      } else {
        var userIdList = this.selectListDelet.map((item) => item.userId);
        this.$confirm("确认要删除选中的考勤人员吗？", "提示", {}).then(() => {
          this.editLoading = true;
          zhInsertClockInPersonnelDelUser(userIdList)
            .then((res) => {
              this.editLoading = false;
              if (res.code === 200) {
                // 获取选中行的 id 集合（建议每行有唯一 id）
                const selectedIds = this.multipleSelection.map(
                  (item) => item.userId,
                );

                // 从 tableData 中过滤掉选中的项
                // this.filteredData = this.filteredData.filter(item => !selectedIds.includes(item.userId));

                // ✅ 关键：清除表格的选中状态
                this.$refs.multipleTable.clearSelection();

                // 可选：清空本地选中数组
                this.selectListDelet = [];
                this.$message({ message: "删除成功", type: "success" });
                this.getUserListByManagementId();
                this.closeClock();
              } else {
                this.$message({
                  message: "删除失败, " + res.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.editLoading = false;
            });
        });
      }
    },
    // 获取绑定的补卡规则
    getRepairRuleManagementList() {
      repairRuleManagementBg(this.managementId).then((res) => {
        this.repairList = res.data;
      });
    },
    // 补卡规则设置
    repairRulesSetUp() {
      this.repairRulesVisible = true;
      this.templateSelection = null;
      repairRuleList({
        companyId: this.$route.query.EId,
      }).then((response) => {
        if (response.code == 200) {
          this.repairRulesList = response.data;
          this.$refs.repairRulesRef.setCurrentRow(this.repairList);

          // this.repairRulesList.forEach((e, index) => {
          //   if (e.id == this.repairList.id) {
          //     console.log(index)
          //     this.$refs.repairRulesRef.setCurrentRow(index + 1)
          //   }
          // })
        }
      });
    },
    // 选中补卡规则
    handleRepairRules(val) {
      this.templateSelection = val.id;
      this.repairRulesSelectVal = val;
    },
    // 补卡规则确认按钮
    submitFormRepairRules() {
      if (this.repairRulesSelectVal == null) {
        this.$message({ message: "请选择补卡规则", type: "warning" });
      } else {
        if (this.repairList != null) {
          updateRepairRuleManagement({
            // id: this.repairList.id,
            ruleId: this.repairRulesSelectVal.id,
            managementId: this.managementId,
          }).then((res) => {
            if (res.code == 200) {
              this.$message({ message: "补卡规则设置成功", type: "success" });
              this.getRepairRuleManagementList();
              this.repairRulesSelectVal = null;
              this.repairRulesVisible = false;
            } else {
              this.$message({ message: res.msg, type: "error" });
            }
          });
        } else {
          addRepairRuleManagement({
            ruleId: this.repairRulesSelectVal.id,
            managementId: this.managementId,
          }).then((res) => {
            if (res.code == 200) {
              this.$message({ message: "补卡规则设置成功", type: "success" });
              this.getRepairRuleManagementList();
              this.repairRulesSelectVal = null;
              this.repairRulesVisible = false;
            } else {
              this.$message({ message: res.msg, type: "error" });
            }
          });
        }
      }
    },
  },
  created() {
    console.log(this.$route.query.EId);
    this.findPage();
    // this.getEList();
    // this.findDeptTree();
  },
};
</script>

<style scoped>
.headerts .el-dialog__body form {
  padding: 0;
}

/deep/ .lang .el-form-item__content {
  width: 81%;
}

.button {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Arial, sans-serif !important;
}

.des {
  color: #00000099;
}

/deep/ .el-radio,
/deep/ .el-drawer__header,
/deep/ .el-form-item__label {
  color: #000000;
}

/deep/ .OA .el-drawer__body {
  border-top: 1px solid #f0f0f0;
}

/deep/ .OA .el-drawer__header {
  margin-bottom: 18px;
}
/deep/ .el-drawer {
  overflow-y: auto;
}

/* // 深度选择器 去掉全选按钮 */
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
  line-height: 37px;
}

::v-deep .map .el-dialog {
  margin-top: 7vh !important;
}
.demo-drawer__footer_bottom {
  position: fixed;
  bottom: 0;
  width: 32%;
  background-color: white;
  margin-bottom: 0 !important;
  padding: 10px 0;
}
</style>
